export const GET_POLICIES = "GET_POLICIES";
export const GET_POLICIES_SUCCESS = "GET_POLICIES_SUCCESS";
export const GET_POLICIES_ERROR = "GET_POLICIES_ERROR";
export const TOGGLE_POLICY_MODAL = "TOGGLE_POLICY_MODAL";

export const ADD_POLICY = "ADD_POLICY";
export const ADD_POLICY_SUCCESS = "ADD_POLICY_SUCCESS";
export const ADD_POLICY_ERROR = "ADD_POLICY_ERROR";

export const GET_POLICY = "GET_POLICY";
export const GET_POLICY_SUCCESS = "GET_POLICY_SUCCESS";
export const GET_POLICY_ERROR = "GET_POLICY_ERROR";

export const UPDATE_POLICY = "UPDATE_POLICY";
export const UPDATE_POLICY_SUCCESS = "UPDATE_POLICY_SUCCESS";
export const UPDATE_POLICY_ERROR = "UPDATE_POLICY_ERROR";

export const DELETE_POLICY = "DELETE_POLICY";
export const DELETE_POLICY_SUCCESS = "DELETE_POLICY_SUCCESS";
export const DELETE_POLICY_ERROR = "DELETE_POLICY_ERROR";

export const GET_DEFAULT_POLICY = "GET_DEFAULT_POLICY";
export const GET_DEFAULT_POLICY_SUCCESS = "GET_DEFAULT_POLICY_SUCCESS";
export const GET_DEFAULT_POLICY_ERROR = "GET_DEFAULT_POLICY_ERROR";
export const SEND_CONTACT_US_MESSAGE = "SEND_CONTACT_US_MESSAGE";
export const SEND_DELETE_ACCOUNT_REQUEST = "SEND_DELETE_ACCOUNT_REQUEST";
